import type { AlertButton, AlertOptions } from "react-native";
export type ProductDialog = { title: string; message?: string; buttons: AlertButton[]; options?: AlertOptions };
let queue: ProductDialog[] = [];
const listeners = new Set<() => void>();
function emit() { listeners.forEach((listener) => listener()); }
export function subscribeDialogs(listener: () => void) { listeners.add(listener); return () => { listeners.delete(listener); }; }
export function getDialog() { return queue[0] ?? null; }
export function resolveDialog(button?: AlertButton) {
  const current = queue[0];
  if (!current) return;
  queue = queue.slice(1);
  emit();
  if (button) button.onPress?.();
  else {
    current.buttons.find((item) => item.style === "cancel")?.onPress?.();
    current.options?.onDismiss?.();
  }
}
export const Alert = {
  alert(title: string, message?: string, buttons?: AlertButton[], options?: AlertOptions) {
    queue = [...queue, { title, message, buttons: buttons?.length ? buttons : [{ text: "OK" }], options }];
    emit();
  },
};
